import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import { getQuoteProProductsApi } from 'api';
import { setQuoteMarketingSegmentData } from 'redux/actions/quote';
import QuoteItems from '../QuoteItems/QuoteItems';
import QuoteGroupInfo from './QuoteGroupInfo';


const QuotingGroupPage = () => {
  const dispatch = useDispatch();
  const params = useParams<{ [id: string]: string }>();

  const { isEavAttributeLoading } = useSelector((state: IReduxState) => state.eavAttributes);
  const {
    loadingQuoteCustomers,
    currentMarketingSegment,
    quoteProductsByGroup,
    quoteProducts,
    quoteGroupsLoading,
    quoteProductsLoading,
    loadingQuoteProductSubscriptionOptions,
  } = useSelector((state: IReduxState) => state.quote);

  const { options } = useSelector((state: IReduxState) => state.eavAttributes);

  const loading =
  loadingQuoteCustomers ||
  isEavAttributeLoading ||
  quoteProductsLoading ||
  loadingQuoteProductSubscriptionOptions ||
  quoteGroupsLoading;

  useEffect(() => {
    if (!Object.keys(quoteProductsByGroup).length && !quoteProducts.length) {
      getQuoteProProductsApi({ dispatch });
    }
  }, []);

  useEffect(() => {
    if (!currentMarketingSegment?.value) {
      dispatch(setQuoteMarketingSegmentData(options?.find((group) => group?.value === params?.id)));
    }
  }, [options]);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting/' },
            { name: 'Marketing Segment Details' }
          ]}
        />
      </div>
      <Grid container spacing={2} className="px-8">
        <Grid item xs={12} md={8}>
          <QuoteItems />
        </Grid>
        <Grid item xs={12} md={4}>
          <QuoteGroupInfo />
        </Grid>
      </Grid>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default QuotingGroupPage;
